// The homepage's shell. It matches Guide/entrypoint/guidepage minus the
// legacy editor, FrameModule and lazysizes code no homepage markup uses.
import 'Shared/mootools';
import 'Guide/guide_constants.js.php';
import 'shared-constants';
import 'Shared/global';
import 'Shared/status';
import 'Shared/notify';
import 'Guide/last_page_cookie';
import 'Shared/login-portal-setup';
import 'Shared/PopupModal';
import 'Shared/ifixit-header-footer';
import 'Shared/toaster';
import { onDomReady } from 'Shared/utils/dom-ready';
import { GoAffPro, trackAnalyticsCustomEvent } from '@ifixit/analytics';
import { AddVercelToolBar } from 'Shared/features';
import Loader from 'Shared/utils/loader';
import './home_page_hero';
import './featured_documents';
import 'Shared/Campaigns/campaign-banner-wp';
import { WPNewsletter } from 'Shared/newsletter';

Loader.initNavEvents();
GoAffPro.trackVisitIfRequired();
AddVercelToolBar();

onDomReady(() => {
   document.querySelectorAll('.newsletter-sub').forEach(newsLetterEl => {
      new WPNewsletter(newsLetterEl, 'Homepage', 'Homepage Banner');
   });

   document.querySelectorAll('.js-product-ad').forEach(el => {
      el.addEventListener('click', () => {
         trackAnalyticsCustomEvent({
            eventCategory: 'Featured Products - Homepage',
            eventAction: `Featured on Homepage - ${el.get('data-ga-product')}`,
         });
      });
   });

   document.querySelectorAll('[data-ga-category]').forEach(el => {
      el.addEventListener('click', () => {
         trackAnalyticsCustomEvent({
            eventCategory: el.dataset.gaCategory,
            eventAction: el.dataset.gaAction,
         });
      });
   });
});
